export interface IRedirectStateLiteToPro {
    state: string;
    params?: object;
}

export enum EParamsName {
    ACTION = "action",
    DOMAIN = "domain",
    KEYWORD = "keyword",
    INDUSTRY = "industry",
    APP_NAME = "appname",
    LITE_REDIRECT = "lite-redirect",
    SOURCE_PAGE = "sourcepage",
    COMPETITOR = "competitor",
    STORE = "store",
    COUNTRY = "country",
    CATEGORY = "category",
    MODE = "mode",
    DEVICE = "device",
    SEARCH_SOURCE = "searchsource",
    PACKAGE = "package",
    WEBSITE = "website",
    LOCALE = "locale",
    SHOULD_SHOW_LOADER = "shouldShowLoader",
    NEW_USER = "newUser",
    CAMPAIGN_ID = "campaignId",
}

export enum EStateNameFromLite {
    KEYWORDS_BANNER = "keywords_banner",
    TECHNOLOGIES_SEEALL = "technologies_seeall",
    WEBSITE_PERFORMANCE = "website-performance",
    TRAFFIC_ENGAGEMENT = "traffic-engagement",
    PAID_LANDING = "paid-landing",
    SEARCH_ADS = "search-ads",
    DISPLAY_CREATIVES = "display-creatives",
    PAID_WEBSITE_ANALYSIS = "paid-websiteanalysis",
    COMPETITORS_PAID_KEYWORDS = "competitors-paid-keywords",
    ORGANIC_WEBSITE_ANALYSIS = "organic-websiteanalysis",
    COMPETITORS_ORGANIC_KEYWORDS = "competitors-organic-keywords",
    SOCIAL_OVERVIEW = "social-overview",
    COMPETITIVE_LANDSCAPE = "competitive-landscape",
    AUDIENCE_GEOGRAPHY = "audience-geography",
    KEYWORDS_SEEALL = "keywords_seeall",
    FIND_SEARCH_TEXT_ADS = "findsearchtextads",
    APP_ANALYSIS = "appanalysis",
    WEB_MARKET_ANALYSIS = "webmarketanalysis",
    KEYWORD_ANALYSIS = "keywordanalysis",
    WEBSITE_ANALYSIS = "website-analysis",
    TOP_WEBSITES = "top-websites",
    TOP_APPS = "top-apps",
    TOP_APPS_TRENDS = "top-apps-trends",
    HOME_PAGE = "home",
    KEYWORD_GENERATOR = "KG",
    KEYWORD_GENERATOR_TABLE_HOOK = "KG_resultpage_tablehook",
    SEO_OVERVIEW = "seo-overview",
    AI_BRAND_VISIBILITY = "ai-brand-visibility",
    AI_TRAFFIC = "ai-traffic",
}
